import React, { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { set_value_properties } from "../../App/actions/propertiesActions";

const C_V_MULTI = React.memo(
  ({ value, isEditing, isViewer, isAllowOtherAnswer, field, row }) => {
    const dispatch = useDispatch();
    const cellRef = useRef(null);

    // --- THE TRIGGER: Activate global editor when isEditing turns true ---
    useEffect(() => {
      if (isEditing && !isViewer && cellRef.current) {
        const base_options = field.array_templates || [];
        let final_options = base_options;

        const parent_array_templates_key = field.parent_array_templates_key;
        const value_parent = row?.properties?.[parent_array_templates_key];

        if (parent_array_templates_key && value_parent) {
          final_options = base_options.filter(
            (item) => item.parent === value_parent,
          );
        }

        dispatch(
          set_value_properties({
            key: "global_cell_editor",
            value: {
              type: field.type,
              anchorEl: cellRef.current,
              row: row,
              field: field,
              value: value,
              options: final_options.length > 0 ? final_options : base_options,
              isAllowOtherAnswer: isAllowOtherAnswer,
            },
          }),
        );
      }
    }, [isEditing, isViewer, field, row, value, isAllowOtherAnswer, dispatch]);

    // --- FORMAT DATA FOR FAST RENDER ---
    // Handle either \n delimited string or raw array
    const parsedValues =
      typeof value === "string" && value
        ? value.split("\n").filter(Boolean)
        : Array.isArray(value)
          ? value
          : [];

    const displayValue = parsedValues.join(", ");

    return (
      <div
        ref={cellRef}
        className="cell_text_fast"
        title={displayValue}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          height: "100%",
          boxSizing: "border-box",
        }}
      >
        <span
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {displayValue || "-"}
        </span>

        {/* Multi-select visual indicator */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#999"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{ flexShrink: 0, marginLeft: "4px" }}
        >
          <line x1="8" y1="6" x2="21" y2="6"></line>
          <line x1="8" y1="12" x2="21" y2="12"></line>
          <line x1="8" y1="18" x2="21" y2="18"></line>
          <line x1="3" y1="6" x2="3.01" y2="6"></line>
          <line x1="3" y1="12" x2="3.01" y2="12"></line>
          <line x1="3" y1="18" x2="3.01" y2="18"></line>
        </svg>
      </div>
    );
  },
);

export default C_V_MULTI;
